import { Component } from '@angular/core';

@Component({
  selector: 'alert-onprem-message',
  templateUrl: './alert-onprem-message.component.html',
  styleUrls: ['./alert-onprem-message.component.css']
})

export class AlertOnPremMessageComponent {
}
